import React, { useEffect } from 'react';
import { Row, Col, Table, Spin, Tooltip } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import FeatherIcon from 'feather-icons-react';

import { RecordViewWrapper } from './Style';
import { Main, TableWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { Cards } from '../../../components/cards/frame/cards-frame';
import { PageHeader } from '../../../components/page-headers/page-headers';
import {
  sucursalListAction,
} from '../../../redux/administracion/sucursales/actionCreator';


const SucursalViewPage = () => {
  const dispatch = useDispatch();
  const isLoading = useSelector(state => state.responseReducer.loading);
  const registros = useSelector(state => state.SucursalReducer.data);

  useEffect(() => {
    if (sucursalListAction) {
      dispatch(sucursalListAction());      
    }
  }, [dispatch]);

  const dataSource = [];

  const onHandleSearch = e => {
    dispatch(sucursalListAction(e.target.value));
  };

  if (registros.length)
    registros.map((record, key) => {
      const { id, estado, municipio, estatus, telefono_principal, nombre } = record;
      return dataSource.push({
        key: key + 1,
        nombre,
        estado,
        municipio,
        estatus: <span className={`${estatus}`}>{estatus}</span>,
        telefono_principal,
        action: (
          <div className="table-actions">
            <Tooltip title="Editar ficha de datos" color="#f8f9ac">
              <Link className="edit" to={`/admin/sucursales/editar/${id}`}>
                <FeatherIcon icon="edit" />
              </Link>
            </Tooltip>
            <Tooltip title="Unidades médicas" color="#f8f9ac">
              <Link className="edit" to={`/admin/sucursales/unidades-medicas/${id}/${nombre}`}>
                <FeatherIcon icon="box" />
              </Link>
            </Tooltip>
            <Tooltip title="Eliminar" color='#f8f9ac'>
              <Button  onClick={() => showModal(id, nombre)}>
                <FeatherIcon icon="trash" />
              </Button>
            </Tooltip> 

            {/* 
            <Tooltip title="Unidades médicas" color='#f8f9ac'>
              <Button  onClick={() => showModal(id, nombre)}>
                <FeatherIcon icon="box" />
              </Button>
            </Tooltip> 
           <Tooltip title="Expediente administrativo" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/expediente/${id}`}>
                <FeatherIcon icon="folder" size={32} />
              </Link>
            </Tooltip>
             &nbsp;&nbsp;&nbsp;
            <Tooltip title="Bonos" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/bonos/${id}`}>
                <FeatherIcon icon="gift" size={24} />
              </Link>
            </Tooltip>
            &nbsp;&nbsp;&nbsp;
            <Tooltip title="Incidencias" color='#f8f9ac'>
              <Link className="edit" to={`/admin/sucursales/incidencias/${id}`}>
                <FeatherIcon icon="meh" size={24} />
              </Link>
        </Tooltip> */}
          </div>
        ),
      });
    });

  const columns = [
    {
      title: 'Estado',
      dataIndex: 'estado',
      key: 'estado',
    },
    {
      title: 'Municipio',
      dataIndex: 'municipio',
      key: 'municipio',
    },
    {
      title: 'Nombre de la sucursal',
      dataIndex: 'nombre',
      key: 'nombre',
    },
    {
      title: 'Teléfono',
      dataIndex: 'telefono_principal',
      key: 'telefono_principal',
    },
    {
      title: 'Estatus',
      dataIndex: 'estatus',
      key: 'estatus',
    },
    {
      title: 'Acciones',
      dataIndex: 'action',
      key: 'action',
      width: '90px',
    },
  ];

  return (
    <RecordViewWrapper>
      <PageHeader
        subTitle={
          <div>
            <Button className="btn-add_new" size="default" key="1" type="primary">
              <Link to="/admin/sucursales/agregar">
                <FeatherIcon icon="plus" size={14} /> <span>Agregar nueva sucursal</span>
              </Link>
            </Button>
          </div>
        }
        buttons={[
          <div key={1} className="search-box">
            <span className="search-icon">
              <FeatherIcon icon="search" size={14} />
            </span>
            <input onChange={onHandleSearch} type="text" name="recored-search" placeholder="Buscar..." />
          </div>,
        ]}
        ghost
        title="SUCURSALES"
      />
      <Main>
        <Row gutter={15}>
          <Col className="w-100" md={24}>
            <Cards headless>
              {isLoading ? (
                <div className="spin">
                  <Spin />
                </div>
              ) : (
                <div>
                  <TableWrapper className="table-data-view table-responsive">
                    <Table
                      pagination={{ pageSize: 10, showSizeChanger: true }}
                      dataSource={dataSource}
                      columns={columns}
                      locale={{ emptyText: 'Sin registros' }}
                    />
                  </TableWrapper>
                </div>
              )}
            </Cards>
          </Col>
        </Row>
      </Main>
    </RecordViewWrapper>
  );
};

export default SucursalViewPage;
